// @flow

import { createValidator, required, type FormValues } from 'gandi.react-form';

const email = (value: any, data: FormValues, props: any) => {
  if (value && !value.match(/.+@.+\..+/)) {
    return props.translator.__('Must be a valid E-mail address');
  }

  return undefined;
};

const file = (field: string) => (value: any, data: FormValues, props: any) => {
  // If we already have an id, the file is valid
  if (typeof data?.[field] === 'string') {
    return undefined;
  }
  // If we didn't yet upload it to the API, let's check the size first
  if (data?.[field]?.size >= 1024 * 1024) {
    return props.translator.__('Must be smaller than 1 MB');
  }
  return undefined;
};
const isRequired =
  (status: string) => (value: any, data: FormValues, props: any) => {
    if (data?.holder_status === status) {
      return required(value, data, props);
    }
    return undefined;
  };

const isRequiredFieldFistnameAndLastName = (
  value: any,
  data: FormValues,
  props: any,
) => {
  if (data?.organization_type === 'individual') {
    return required(value, data, props);
  }
  return undefined;
};

const isRequiredFieldOrgname = (value: any, data: FormValues, props: any) => {
  if (data?.organization_type !== 'individual') {
    return required(value, data, props);
  }
  return undefined;
};

export default (createValidator({
  organization_type: required,
  mark_name: required,
  registration_number: required,
  jurisdiction: required,
  orgname: isRequiredFieldOrgname,
  firstname: isRequiredFieldFistnameAndLastName,
  lastname: isRequiredFieldFistnameAndLastName,
  email: [required, email],
  holder_status: required,
  declaration_proof_of_use: [required, file('declaration_proof_of_use')],
  proof_of_use: [required, file('proof_of_use')],
  assignee_declaration: [isRequired('assignee'), file('assignee_declaration')],
  licensee_declaration: [isRequired('licensee'), file('licensee_declaration')],
  duration: [required],
}): any);
